import { useQuery } from "@tanstack/react-query";
import { getCalls, CallsListParams } from "../../api/call/call.api";
import { qk } from "../../lib/queryKeys";

export function useGetCalls(params?: CallsListParams) {
  return useQuery({
    queryKey: qk.calls(params),
    queryFn: () => getCalls(params),
    staleTime: 30_000,
  });
}
